import { ApiClient } from "@/api-client/src/core/api-client";
import { MenuResponse } from "@/packages/types/menu";

const apiClient = new ApiClient();
const webService = apiClient.web;

export const fetchFooterQuicklinks = async (): Promise<MenuResponse> => {
  const response = await webService.get<MenuResponse>(`/mega-menu`);
  return response;
};
export const fetchFooterPolicies = async (): Promise<MenuResponse> => {
  const response = await webService.get<MenuResponse>(`/mega-menu`);
  return response;
};
export const fetchFooterMenu = async (): Promise<MenuResponse> => {
  const response = await webService.get<MenuResponse>(`/mega-menu/footer`);
  return response;
};
